import { render, staticRenderFns } from "./OrdersEditModalTables.vue?vue&type=template&id=703e6172&"
import script from "./OrdersEditModalTables.vue?vue&type=script&lang=js&"
export * from "./OrdersEditModalTables.vue?vue&type=script&lang=js&"
import style0 from "./OrdersEditModalTables.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports